/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Recipe_Delete_BodyInputs */

const en_recipe_delete_body = /** @type {(inputs: Recipe_Delete_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.title}" will be removed from your household's recipes.`)
};

const de_recipe_delete_body = /** @type {(inputs: Recipe_Delete_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`„${i?.title}“ wird aus den Rezepten deines Haushalts entfernt.`)
};

/**
* | output |
* | --- |
* | "\"{title}\" will be removed from your household's recipes." |
*
* @param {Recipe_Delete_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_delete_body = /** @type {((inputs: Recipe_Delete_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Delete_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_delete_body(inputs)
	return en_recipe_delete_body(inputs)
});